import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: 44 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.div>
    );
}
